var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div style="position: relative"> <div class="nfd-menu-list__title"data-bind="click: _onClick"> <a class="padding-ms--5 nfd-text-gold nfd-text-normal pointer"data-bind="text: title"></a> <i class="nfd-anim-mini nfd-icon nfd-icon-arrow-orange nfd-icon-arrow-down"data-bind="css: { \'nfd-icon-arrow-up\': _expanded }"> </i> </div><!-- ko if: _expanded() --> <div data-bind="template: { afterRender: _afterRender }"> <div class="nfd-menu-list"data-bind="style: _menuStyle"> <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko --> </div> </div><!-- /ko --> </div>';
}
return __p;
};
